import md5 from "md5";
export const getSign = (data) => {
    const salt = "8ce01a1c167b";
    const timestamp = new Date().getTime();
    const sign = [];
    sign.push(salt);
    sign.push(timestamp);
    Object.keys(data).forEach((key) => {
        sign.push(data[key]);
    });
    const res = {
        sign: md5(sign.sort().join("")),
        timestamp,
    };
    return res;
};
export const getSignJson = (data) => {
    const salt = "8ce01a1c167b";
    const timestamp = new Date().getTime();
    const sign = [];
    sign.push(salt);
    sign.push(timestamp);
    sign.push(JSON.stringify(data));
    const res = {
        sign: md5(sign.sort().join("")),
        timestamp,
    };
    return res;
};
